//ESRI Imports
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import * as projection from "@arcgis/core/geometry/projection.js";
import * as urlUtils from "@arcgis/core/core/urlUtils.js";
import Extent from "@arcgis/core/geometry/Extent.js";
import  esriId from "@arcgis/core/identity/IdentityManager.js";

let loaderDiv = document.getElementById('loaderDiv');
let loader = loaderDiv.children[0]; 

esriId.on("dialog-create", function() {
	esriId.dialog.visible = false;

	window.setTimeout(function() {
		esriId.dialog.content.emit("cancel", {});
	}, 250);
});

// global container containing the map objects
export let WinGISMap = {
    map: null, 
    view: null,
}

function increaseLoad()
{
  let val = loader.value + 8; 
  if (val<100){
    loader.value = val
  }
  else {
    loader.value = 100; 
  }
}

let esriServices = {}; 


export async function createMap(conditionalMapOptions) {

    esriServices.projection = projection; 
    esriServices.projection.load(); 
 
  /* INITIAL MAP START*/ 
  //InitializeMap returns array containing basic map and view objects, deconstructs array into WinGISMap properties
  let results = await (await import("./general/initializeMap.js")).default(conditionalMapOptions);
  [WinGISMap.map, WinGISMap.view] = results; 

  increaseLoad()


  /*SIMPLE UI */
  //Adds simple buttons (the ones inside the view.) 
  if (conditionalMapOptions.addSimpleUI){
    (await import("./UI/simpleUI.js")).default(WinGISMap, conditionalMapOptions);
    console.log("after ui");    
  }

  increaseLoad()

  /*ADVANCED UI*/
  //Adds sidebar
  if (conditionalMapOptions.addAdvancedUI)
  {
    await (await import("./UI/advancedUI.js")).default(WinGISMap, conditionalMapOptions.type); 
    console.log("after advui");   
  }
  increaseLoad()
  //Themes in the future?
  // else if (conditionalMapOptions.UI) {
  //   await import("UI/" + conditionalMapOptions.UI + ".js", WinGISMap);
  // }

  if (conditionalMapOptions.addMarkup) {
    if (!esriServices.geometryEngine)
      {

          esriServices.geometryEngine = geometryEngine;
     
      }
      await (await import("./general/initializeMarkup.js")).default(WinGISMap,  esriServices);
  }
  increaseLoad()
  if (conditionalMapOptions.addMeasure) {
    await (await import ("./general/initializeMeasure.js")).default(WinGISMap, conditionalMapOptions);
  }
  increaseLoad()
  //adds property search based on value
  if (conditionalMapOptions.propertySearch)
  { 
    await (await import ("./general/initializePropetySearch.js")).default(WinGISMap, conditionalMapOptions); 
  }
  increaseLoad()
  if(conditionalMapOptions.intersectionLocator)
  {
    await (await import("./general/initializeAddressIntersection.js")).default(WinGISMap, conditionalMapOptions); 
  }
  increaseLoad()
  if (conditionalMapOptions.extraSearch)
    {
      
      let InitializeExtraSearch = (async function () {
        
        let Search; 
        try { 
          let SearchModule; 
          SearchModule = await import("./extrasearches/" + conditionalMapOptions.extraSearch + ".js");
          Search = SearchModule.default;
        } catch (error) {
          console.error("Error importing search module:", error);
        }
        document.getElementById("btn" + conditionalMapOptions.extraSearch + "search").addEventListener("click", (() => {
          Search(WinGISMap, conditionalMapOptions); 
        }))
      });

      InitializeExtraSearch(); 

    }
    increaseLoad()
  /*LAYER ADDITION*/
  //if any layers set, add them to the map.
  if (conditionalMapOptions.layers && Object.keys(conditionalMapOptions.layers).length > 0)
    {        
      (await import("./general/addLayers.js")).default(WinGISMap, conditionalMapOptions);       
      console.log("after layers");   
    }       
    increaseLoad()

  if (conditionalMapOptions.propertySearch || conditionalMapOptions.identifyOnClick){
    (await import("./general/initializeSummaries.js")).default(WinGISMap, conditionalMapOptions);
  }
  increaseLoad()

  /*
    ADDS IDENTIFY 
  */
  // allows users to identify elements when they click
  if (conditionalMapOptions.identifyOnClick)
  { 
    await (await import("./general/initializeIdentify.js")).default(WinGISMap, conditionalMapOptions); 
    esriServices.projection.load();
  }
  increaseLoad()
  // adds a widget that contains some basic map settings, like light/dark mode.
  if (conditionalMapOptions.enableOptions !== false)
  {
    await (await import(`./general/initializeOptions.js`)).default(WinGISMap, conditionalMapOptions);
  }
  increaseLoad()

  //Extra modules get included here. Potentially modules could be reworked to fire this way in the future.
  if (conditionalMapOptions.extras)
    { 
      for(let i = 0; i < conditionalMapOptions.extras.length; i++)
      {
        let setupExtra = (async function () {
          let Extra; 
          try { 
            let ExtraModule; 
            ExtraModule = await import("./extras/" + conditionalMapOptions.extras[i] + ".js");
            Extra = ExtraModule.default;
            Extra(WinGISMap, conditionalMapOptions);
          } catch (error) {
            console.error("Error importing extra module:", error);
          }
        })
        setupExtra(); 

      }
    }
    increaseLoad()

      let skipToMap = document.getElementById("skipToMap"); 

      skipToMap.addEventListener("keypress" , function(e){ 
          if(e.key = "Enter")
          {
            WinGISMap.view.focus(); 
          }
      });
      skipToMap.addEventListener("click" , function(e){ 
          WinGISMap.view.focus(); 
        });
      loaderDiv.classList.add("hidden"); 
      loaderDiv.addEventListener("transitionend",() => {
      loaderDiv.remove();
    })

  //  document.querySelector(".mapContainer").classList.remove("hiddenElem");
  //  document.querySelector(".mapContainer").classList.add("shown");
    return WinGISMap;
}


// small utility functions

//starts the proxy
export function InitializeProxy () {
  if (window.location.href.includes("localhost"))
  {
    urlUtils.addProxyRule({
      urlPrefix: "maps.wingis.org",
      proxyUrl: "/proxy"
    });
  }
  else {
    urlUtils.addProxyRule({
      urlPrefix: "maps.wingis.org",
      proxyUrl: "/proxy/proxy.ashx"
    });
  }

    
    //   urlUtils.addProxyRule({
    //     urlPrefix: "agis.wingis.org",
    //     proxyUrl: "/proxy/proxy.ashx"
    // });
}

// sets an active tool to restrict certain actions until a tool is de-active 
export function setActiveButton(selectedButton, view) {
  // focus the view to activate keyboard shortcuts for sketching
  if (view)
  {
    view.focus();
  }

  let tools = document.querySelectorAll("calcite-action[active]");
  if(tools)
  {
    tools.forEach((tool) => {
      tool.active = false;
    })
  }
  let elements = document.getElementsByClassName("active-tool");
  if (elements)
  {
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove("active-tool");
    }
  }
  if (selectedButton) {
    selectedButton.classList.add("active-tool");
    selectedButton.active = 'true';
  }
}
// zooms to an extent based on parameters 
// use view.GoTo() instead. Smoother, easier, faster. 
async function SelParcelZoom(xmin, ymin, xmax, ymax){

    //alert(ymax);
    let newExt = new Extent({
      spatialReference: {
        wkid: 3436
      }
    })
  
    newExt.xmin= xmin;
    newExt.ymin= ymin;
    newExt.xmax= xmax;
    newExt.ymax= ymax;
    WinGISMap.view.extent = newExt;


}

//zooms to a municipality based on the name passed to it
export function municZoom(selectedMunicipality) {
  import ("./util/extents.js").then((module) => {
    let extents = module.extents; 
    let newExt = { spatialReference: {
      wkid: 3436
  }}; 
    let extent = extents[selectedMunicipality];
    newExt.xmin = extent.xmin;
    newExt.xmax = extent.xmax; 
    newExt.ymin = extent.ymin; 
    newExt.ymax = extent.ymax;
  
    WinGISMap.view.extent = newExt;

  })
}
window.municZoom = municZoom;

// utility function that runs the default function from a path. 
//path: string without a leading / of a module.
//...args : any arguments to be passed to the function.
// Utility function that runs the default function from a path.
// async function runDefaultFunctionFromPath(relativePath, ...args) {
//   try {
//       // Ensure the relativePath does not start with './' as require.context expects paths relative to the context.
//       const normalizedPath = relativePath.startsWith('./') ? relativePath : `./${relativePath}`;

//       // Create a context for all JavaScript files in the directory and subdirectories
//       const context = require.context('./', true, /\.js$/, 'lazy');

//       // Resolve the module using the context
//       const module = context(normalizedPath);

//       // Check if the module is resolved correctly and has a default export function
//       if (module && typeof module.default === 'function') {
//           // Await the result of the default function to handle any asynchronous operation within
//           return await module.default(...args);
//       } else {
//           throw new Error(`Module at ${relativePath} does not have a default export or is not a function`);
//       }
//   } catch (error) {
//       console.error("Error executing default function from path:", error);
//       throw error; // Rethrow the error after logging for higher-level handling
//   }
// }


// returns x and y coordinates in an object from a mappoint using projection.
export  function GetCoordinatesFromPoint (mapPoint) {



          let outSpatialReference = {
            wkid: 4326
          };
        
          let projectedPoints = esriServices.projection.project([mapPoint], outSpatialReference); 
      
        let coordinates; 
      
        if (projectedPoints[0].extent) {
      
            coordinates = {
                x: projectedPoints[0].extent.center.x,
                y: projectedPoints[0].extent.center.y,
            }
      
        }
        else {
            coordinates = {
                x: projectedPoints[0].x,
                y: projectedPoints[0].y,
            }
        }
          return(coordinates); 
  
   

 

}